export const maxRects = 10;
